// extracted by mini-css-extract-plugin
export default {"wrap":"oI-z","fullWidth":"pI-z","hideOnDesktop":"qI-z","content":"rI-z","hasOpenedNav":"sI-z","crumbsList":"tI-z","dropdownsWrap":"uI-z"};